import { Slider } from '@mui/material';
import { FC, MouseEvent, useCallback, useState } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { formatTime } from '../../../helpers';
import { SeekHoverController } from './SeekHoverController';

type SeekbarProps = {
  position: number;
  min?: number;
  max: number;
};

export const Seekbar: FC<SeekbarProps> = ({ position, min = 0, max }) => {
  const { player } = usePlayerContext();

  const [hovering, setHovering] = useState(false);
  const [hoveringValue, setHoveringValue] = useState({
    position: 0,
    value: '00:00',
  });

  const seek = (position: number) => {
    const video = player?.getMediaElement();
    if (video) video.currentTime = position;
  };

  const sliderHover = useCallback(
    (ev: MouseEvent<HTMLSpanElement>) => {
      const rect = ev.currentTarget.getBoundingClientRect();
      const x = ev.clientX - rect.left;
      const hoverProgress = x / ev.currentTarget.clientWidth;

      const duration = max - min;
      const currentPos = duration * hoverProgress;

      const hoverCurrent = player?.isLive() ? duration - currentPos : duration * hoverProgress;
      const formatted = formatTime(Math.floor(hoverCurrent));

      setHoveringValue({
        position: x,
        value: player?.isLive() ? `-${formatted}` : formatted,
      });
    },
    [player, min, max],
  );

  return (
    <>
      {hovering && <SeekHoverController value={hoveringValue} />}
      <Slider
        value={position}
        color="secondary"
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        onMouseMove={sliderHover}
        onChange={(_, newValue: number | number[]) => seek(newValue as number)}
        min={min}
        max={max}
        sx={{ marginBottom: '8px', width: 'calc(100% - 20px)' }}
      />
    </>
  );
};
